import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  returnRewardButtonTitle: {
    id: 'offer-details:return-reward:button-title',
    defaultMessage: 'Return reward',
    description: 'Return reward button title',
  },
  returnRewardConfirmationTitle: {
    id: 'offer-details:return-reward-confirm:title',
    defaultMessage: 'Please confirm',
    description: 'Return reward confirmation title',
  },
  returnRewardConfirmationText: {
    id: 'offer-details:return-reward-confirm:text',
    defaultMessage: 'Are you sure you want to return this reward?',
    description: 'Return reward confirmation text',
  },
  returnRewardConfirmationButtonTitle: {
    id: 'offer-details:return-reward-confirm:button-title',
    defaultMessage: 'Confirm return',
    description: 'Return reward confirmation button title',
  },
  returnRewardForCentsSuccessText: {
    id: 'offer-details:pointsStrategy:cents:return-reward:success-text',
    defaultMessage: 'Returning your reward. Your balance will be restored in a few minutes',
    description: 'Return reward success text for points strategy "Cents"',
  },
  returnRewardForPointsSuccessText: {
    id: 'offer-details:pointsStrategy:points:return-reward:success-text',
    defaultMessage: 'Returning your reward. Your points balance will be restored in a few minutes',
    description: 'Return reward success text for points strategy "Points"',
  },
  'offer-details:location-constraint:title:available-at-all-stores': {
    id: 'offer-details:location-constraint:title:available-at-all-stores',
    defaultMessage: 'Available at all stores',
    description: 'Offer Details popup > location constraint section title if offer available at all stores',
  },
  'offer-details:location-constraint:title:may-not-be-available-at-nearby-stores': {
    id: 'offer-details:location-constraint:title:may-not-be-available-at-nearby-stores',
    defaultMessage: 'May not be available at nearby stores',
    description:
      'Offer Details popup > location constraint section title if offer may not be available at nearby stores',
  },
  'offer-details:location-constraint:title:available-at-these-nearby-stores': {
    id: 'offer-details:location-constraint:title:available-at-these-nearby-stores',
    defaultMessage: 'Available at these nearby stores:',
    description: 'Offer Details popup > location constraint section title if offer available at specific stores nearby',
  },
  'offer-details-qr:scan-at-register:title': {
    id: 'offer-details-qr:scan-at-register:title',
    defaultMessage: 'SCAN AT THE REGISTER',
    description: 'QR code section title',
  },
  'offer-details-qr:scan-at-register:helper-text': {
    id: 'offer-details-qr:scan-at-register:helper-text',
    defaultMessage: 'If you have trouble scanning the code, please increase your screen brightness.',
    description: 'Helper text for QR code scanning',
  },
  'offer-details-qr:close:button': {
    id: 'offer-details-qr:close:button',
    defaultMessage: 'CLOSE',
    description: 'Close button for QR code modal',
  },
});
